import React, { useState } from "react";
import { Link, useNavigate ,useLocation} from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "./Login.css";
import "react-toastify/dist/ReactToastify.css";
import { Eye, EyeOff } from "lucide-react";

const Login = () => {

   const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || "/";
  const [email, setEmail] = useState(""); // email only
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [otpModal, setOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [userId, setUserId] = useState(null);

  const [loading, setLoading] = useState(false);

  const urlmain = process.env.REACT_APP_API_BASE_URL;

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  // 🔹 Step 1: Normal login
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setLoading(true);

  //   try {
  //     const response = await fetch(`${urlmain}/adminlogin`, {
  //       method: "POST",
  //       credentials: "include",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({ email, password }),
  //     });

  //     const res = await response.json();
  //     console.log("Login response:", res);

  //     if (!response.ok) {
  //       toast.error(res.message || "Invalid credentials");
  //       setLoading(false);
  //       return;
  //     }

  //     // Sav    // ✅ Do your login API call here
  //   localStorage.setItem("accessToken", token);
  //   navigate(from, { replace: true }); // redirect to original page
  

  //     if (res.verify) {
  //       // Requires OTP
  //       setUserId(res.data?.main_id);
  //       sendOtp(res.data?.main_id);
  //     } else {
  //       // Direct login
  //       toast.success("Login successful!");
  //       navigate("/");
  //     }
  //   } catch (err) {
  //     console.error(err);
  //     toast.error("Something went wrong, try again!");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const response = await fetch(`${urlmain}/adminlogin`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email, password }),
    });

    const res = await response.json();
    console.log("Login response:", res);

    if (!response.ok) {
      toast.error(res.message || "Invalid credentials");
      setLoading(false);
      return;
    }

    // ✅ Save token if available
    if (res.token) {
      localStorage.setItem("accessToken", res.token);
      navigate(from, { replace: true });
    }

    if (res.verify) {
      // Requires OTP
      setUserId(res.data?.main_id);
      sendOtp(res.data?.main_id);
    } else {
      // Direct login
      toast.success("Login successful!");
      navigate("/");
    }
  } catch (err) {
    console.error(err);
    toast.error("Something went wrong, try again!");
  } finally {
    setLoading(false);
  }
};

  // 🔹 Step 2: Send OTP if required
  const sendOtp = async (user_id) => {
    try {
      const response = await fetch(`${urlmain}/two-step/login/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id }),
      });

      const res = await response.json();
      console.log("Send OTP:", res);

      if (response.ok) {
        setOtpModal(true);
        toast.success("OTP sent successfully!");
      } else {
        toast.error(res.message || "Failed to send OTP");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error sending OTP");
    }
  };

  // 🔹 Step 3: Verify OTP
  const handleVerifyOtp = async () => {
    if (!otp) {
      toast.error("Please enter OTP");
      return;
    }

    try {
      const response = await fetch(`${urlmain}/two-step/login/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ otp, user_id: userId }),
      });

      const res = await response.json();
      console.log("Verify OTP:", res);

      if (response.ok) {
        toast.success("Login successful!");
        setOtpModal(false);
        navigate("/");
      } else {
        toast.error(res.message || "Invalid OTP");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error verifying OTP");
    }
  };

  // 🔹 Logout
  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="login-bg">
        <div className="login-box">
          <h2>Login</h2>
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <div className="password-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <span className="toggle-icon" onClick={togglePassword}>
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </span>
            </div>

            <p className="register">
              By continuing, I agree to the{" "}
              <Link to="/terms-and-conditions">Terms of Use</Link> &{" "}
              <Link to="/privacy-policy">Privacy Policy</Link>
            </p>

            <button type="submit" disabled={loading}>
              {loading ? "Loading..." : "Continue"}
            </button>
          </form>

          {/* OTP Modal */}
          {otpModal && (
            <div className="setting-cart-modal">
              <div className="setting-cart-modal-content">
                <h3 className="setting-payment-modal-title" style={{ textAlign: "center" }}>
                  OTP Verification
                </h3>

                <label className="setting-payment-label">Enter OTP</label>
                <input
                  type="text"
                  className="setting-payment-input"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleVerifyOtp()}
                />

                <div className="setting-payment-modal-actions">
                  <button className="setting-payment-save" onClick={handleVerifyOtp}>
                    Verify
                  </button>
                  <button
                    className="setting-payment-cancel"
                    onClick={() => setOtpModal(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          )}

          <Link to="/reset" style={{ textDecoration: "none" }}>
            <p className="reset-btn">Forgot Password?</p>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Login;
